import React from 'react'
import ReactDom from 'react-dom'
import Item from './Item'
import { trackEvent } from '../../utilities/analytics'

class Select extends React.Component {

  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.currentFloor !== this.props.currentFloor
    || nextProps.units !== this.props.units
  }

  handleChange(event) {
    if (this.props.onChange) {
      event.preventDefault()

      const value = event.currentTarget.getAttribute('data-value')

      trackEvent({
        category: 'Floor List',
        action: 'Click',
        label: `Floor ${value}`
      })

      this.props.onChange({
        valueFor: 'floor',
        value: value
      })
    }
  }

  render() {
    let {
      currentFloor,
      direction,
      displayCount,
      floors,
      units
    } = this.props

    if (direction === 'asc') {
      floors.sort((a, b) => (a.value - b.value))
    } else if (direction === 'desc') {
      floors.sort((a, b) => (b.value - a.value))
    }

    return (
    <div id="floor-horizontal-select">
      <div className="floor-horizontal-container">
          {floors.map((floor, index) => {
            return <Item
                    currentFloor={currentFloor}
                    displayCount={displayCount}
                    floor={floor}
                    key={'floor' + index}
                    onChange={this.handleChange}
                    unitCount={floor.count} />
          })}
      </div>
    </div>
    )
  }
}

Select.defaultProps = {
  currentFloor: null,
  direction: 'asc',
  displayCount: true,
  floors: {},
  units: []
}

export default Select
